import { jsx as _jsx } from "react/jsx-runtime";
import { BaseWidget } from "./shared/BaseWidget";
import { resolveWidgetTheme } from "./shared/resolveWidgetTheme";
import { MedosThemeProvider } from "../react/ThemeProvider";
import { PatientPortalWidget } from "../components/portal/PatientPortalWidget";
import { resolveOtpChannels } from "../utils/resolveOtpChannels";
class MedosPatientPortalWidget extends BaseWidget {
    getModalId() {
        return "medos-patient-portal-modal";
    }
    getWidgetContentId() {
        return "medos-patient-portal-content";
    }
    getIssuer() {
        return "portal-widget";
    }
    renderComponent() {
        if (!this.root || !this.config)
            return;
        const config = this.config;
        this.root.render(_jsx(MedosThemeProvider, { theme: resolveWidgetTheme(config), children: _jsx(PatientPortalWidget, { maxWidth: config.maxWidth, maxHeight: config.maxHeight, otpChannels: resolveOtpChannels(config.otpChannels), onError: (error) => config.onError?.(error) }) }));
    }
}
const widgetInstance = new MedosPatientPortalWidget();
if (typeof window !== "undefined") {
    window.MedosPatientPortal = {
        init: (config) => widgetInstance.init(config),
        open: (config) => widgetInstance.open(config),
        close: () => widgetInstance.close(),
    };
}
export default widgetInstance;
